import { dialogService } from '@thefarmersfront/kitchen';

import { PATH, PUBLIC_PATHS } from '~/constants/path';

import { saveLoginRedirectPath } from './loginRedirect';

/** 로그인 세션 없이 머무는 화면. 여기서 받은 401은 로그인 화면으로 보낼 이유가 없다. */
const NO_SESSION_PATHS: string[] = [...PUBLIC_PATHS, PATH.LOGIN, PATH.LOGOUT];

let isAuthExpiredDialogOpen = false;

/**
 * 토큰 인증 실패 다이얼로그를 띄우고, 확인 시 로그아웃 화면으로 보낸다.
 *
 * 만료된 화면은 요청마다, 탭 복귀·재연결 재조회 때마다 401을 다시 받으므로 이미 떠 있으면 띄우지 않는다.
 */
export const showAuthExpiredDialog = (message?: string): void => {
  if (isAuthExpiredDialogOpen || NO_SESSION_PATHS.includes(window.location.pathname)) {
    return;
  }

  isAuthExpiredDialogOpen = true;

  dialogService.addDialog({
    title: '토큰 인증 실패',
    children: (
      <>
        {message ?? '토큰 인증에 실패했습니다.'}
        <br />
        {'확인'} 선택 시 로그인 화면으로 이동합니다.
      </>
    ),
    onConfirm: () => {
      isAuthExpiredDialogOpen = false;

      saveLoginRedirectPath(`${window.location.pathname}${window.location.search}`);

      if (window.globalNavigate) {
        window.globalNavigate(PATH.LOGOUT);
      } else {
        window.location.href = PATH.LOGOUT;
      }
    },
  });
};
